import type { RequestConfig } from '@umijs/max';
import { history } from '@umijs/max';
import { message } from 'antd';
import { getToken, clearToken } from '@/utils/auth';
import type { Result } from '@/utils/request';

const loginPath = '/user/login';

/**
 * @name 错误处理
 * 对接 tRPC 后端：响应 {Code, Message, Data}
 *  - Code === 200 成功
 *  - Code === 41  未登录（RetServerAuthFail），跳转登录页
 *  - 其他 Code 为业务错误，message 提示
 */
export const errorConfig: RequestConfig = {
    errorConfig: {
        errorThrower: () => {
            // tRPC 业务错误在 body 的 Code 字段，由 responseInterceptors 处理
        },
        errorHandler: (error: any, opts: any) => {
            if (opts?.skipErrorHandler) throw error;
            if (error.response) {
                message.error(`Response status:${error.response.status}`);
            } else if (error.request) {
                message.error('None response! Please retry.');
            } else {
                message.error('Request error, please retry.');
            }
        },
    },

    // 请求拦截器：附加 JWT
    requestInterceptors: [
        (config: any) => {
            const token = getToken();
            if (token) {
                config.headers = {
                    ...config.headers,
                    Authorization: `Bearer ${token}`,
                };
            }
            return config;
        },
    ],

    // 响应拦截器：解析 {Code, Message, Data}
    responseInterceptors: [
        (response: any) => {
            if (response.status === 401) {
                clearToken();
                history.push(loginPath);
                return response;
            }

            const result = response.data as Result<any>;
            if (result.Code === 200) {
                return response;
            } else if (result.Code === 41) {
                clearToken();
                history.push(loginPath);
                const error: any = new Error(result.Message || 'Unauthorized');
                error.code = result.Code;
                throw error;
            } else {
                message.error(result.Message || `Request failed with code: ${result.Code}`);
                const error: any = new Error(result.Message || `Request failed with code: ${result.Code}`);
                error.name = 'BizError';
                error.code = result.Code;
                throw error;
            }
        },
    ],
};
